import React, { useEffect } from "react";
import { useNavigate } from "@tanstack/react-router";
import { useFaceitCallbackMutation } from "@entities/Faceit/FaceitloginApi";

const FaceitCallbackPage: React.FC = () => {
  const navigate = useNavigate();
  const [faceitCallback] = useFaceitCallbackMutation();

  useEffect(() => {
    const code = new URLSearchParams(window.location.search).get("code");
    const state = new URLSearchParams(window.location.search).get("state");
    console.log("code FaceitCallback", code);
    console.log("state FaceitCallback", state);

    if (!code || !state) {
      navigate({ to: "/", replace: true });
      return;
    }

    faceitCallback({ code, state })
      .unwrap()
      .then((result) => {
        if (result.success) {
          navigate({ to: "/", replace: true });
        }
      })
      .catch((error) => {
        console.error("Ошибка авторизации Faceit:", error);
        navigate({ to: "/", replace: true });
      });
  }, [navigate, faceitCallback]);

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
      }}
    >
      Выполняется авторизация Faceit...
    </div>
  );
};

export default FaceitCallbackPage; 